<template>
	<div class="">
		
		<fetch-json url="regions" method="get">
			<div class="" slot-scope="{ data: regions, loading }">
				<div v-if="loading" class="text-grey-darker">
					Loading...
				</div>
				<div v-else>
					<div class="flex py-2 my-2 text-sm">
						<div class="ml-1 flex items-center">
							<div class="w-3 h-3 rounded-full border border-transparent bg-red-400 ml-1"></div>
							<span class="ml-1">new</span>
						</div>
						<div class="ml-1 flex items-center">
							<div class="w-3 h-3 rounded-full border border-red-400 ml-1"></div>
							<span class="ml-1">processing</span>
						</div>
						<div class="ml-1 flex items-center">
							<div class="w-3 h-3 rounded-full border border-transparent bg-yellow-500 ml-1"></div>
							<span class="ml-1">problem</span>
						</div>
						<div class="ml-1 flex items-center">
							<div class="w-3 h-3 rounded-full border border-transparent bg-gray-300 ml-1"></div>
							<span class="ml-1">complete</span>
						</div>
					</div>
					<div class="flex justify-between items-center px-4 py-2 bg-gray-200 mb-4" v-for="region in regions" :key="region.id" >
						<router-link class="flex flex-col items-center m-2 text-xs text-red-600" :to="`/forecast/${region.id}/orders/`">
						<h2 class="text-xl font-normal sm:text-3xl">{{ region.name }}</h2>
						<!-- <div class="flex justify-end items-center text-blue-400">
							<router-link class="flex flex-col items-center m-2 text-xs text-red-600" :to="`/forecast/${region.id}/orders/${firstdate}`">
								<action-button class="btn btn-blue flex items-center">
									<div class="w-3 h-3 rounded-full border" :class="`${status[region.id][firstdate]}Class`"></div>
									<span>{{ firstdate_string }}</span>
								</action-button>
							</router-link>
							<router-link class="flex flex-col items-center m-2 text-xs text-red-600" :to="`/forecast/${region.id}/orders/${seconddate}`">
								<action-button class="btn btn-blue flex items-center">
									<div class="w-3 h-3 rounded-full border" :class="`${status[region.id][seconddate]}Class`"></div>
									<span>{{ seconddate_string }}</span>
								</action-button>
							</router-link>
						</div> -->
						</router-link>
					</div>
				</div>
			</div>
		</fetch-json>
	</div>
</template>

<script>
export default {
	name: 'region',
	data () {
		return {
			role: null,
			userid: null,
			
		}
	},
	methods: {
		
	},
	components: {
		
	},
	created () {
		console.log(this.$router);
		this.role = this.$store.getters['auth/role']
		this.userid = this.$store.getters['auth/userid']
		this.$store.commit('setJobName', null)
	}
}
</script>
<style lang="css" scoped>
	.newClass {
		@apply border-transparent bg-red-400;
	}
	.processingClass {
		@apply border-red-400;
	}
	.problemClass {
		@apply border-transparent bg-yellow-500;
	}
	.completeClass {
		@apply border-transparent bg-gray-300;
	}
</style>
